import React, { useEffect } from "react";
import Aos from 'aos';
import 'aos/dist/aos.css';
import {
  portfolioImages
} from "../utils/images";

const Work = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 })
  }, [])
  
  return (
    <div name="work" className=" w-full bg-[#0a192f] text-gray-300 pt-24 pb-80">
      <div className="max-w-[1500px]  mx-auto p-4 w-full flex flex-col justify-center min-h-full">
        <div className="pb-6 " data-aos='slide-right'  >
          <p className="text-4xl font-bold inline border-b-4 border-pink-600">
            Work
          </p>
          <p className="pt-2">
            Check out some of my recent work
            <span className="text-pink-600">...</span>
          </p>
        </div>
        {/* Container */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
          {
            portfolioImages.map((item, index) => (
              <div key={index} style={{ backgroundImage: `url(${item})`, backgroundSize: '100% 100%' }} data-aos='fade-up' data-aos-delay='200'
                className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div">
                {/* Hovereffect */}
                {/* <div className="opacity-0 group-hover:opacity-100 text-center content-div rounded-md">
              <div className="flex flex-col" >
                <span className="text-xl font-bold text-gray-300 m-4">
                  CryptoZen - A Cryptocurrency tracker
                </span>
                <div className="flex gap-4 text-xl items-center justify-center mt-2">
                  <SiReact size={30} className='text-blue-500' />
                  <SiTailwindcss size={30} className='text-blue-700' />
                  <SiFirebase size={30} className='text-yellow-500' />
                </div>
              </div>
              <div className="pt-2 text-center">
                <a href="https://cryptozen-rt.netlify.app" target='_blank' rel='noreferrer'>
                  <button className="text-center border border-pink-600 text-pink-600 rounded-xl px-4 hover:bg-pink-600 hover:text-gray-300 py-2 m-2 font-bold text-lg">
                    Demo
                  </button>
                </a>
                <a href="https://github.com/topcook/Cryptozen" target='_blank' rel='noreferrer'>
                  <button className="text-center border border-pink-600 text-pink-600 rounded-xl px-4 hover:bg-pink-600 hover:text-gray-300 py-2 m-2 font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div> */}
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
};

export default Work;
